
export default {
    name: 'appFooter',
    props: {
        tempId: String
    },
    serverCacheKey: props => props.tempId
}
